import { PageNormalOrders } from "./orders";
import {PageCryptoOrders} from './CryptoOrders';
import { useSearchParams } from "react-router-dom";
import { OrderMarketType } from "@/constants/order";


export const PageOrders = () => {
  const [params] = useSearchParams();
  return params.get('type') === OrderMarketType.NORMAL? <PageNormalOrders /> : <PageCryptoOrders />
};
